import { COLORS } from '@/config/colors';
import { css, fillOutlined, circle, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const PLATE = 0x6e5236; // dark granite armor

/**
 * B8 Granite Fist — earth Elemental. A boulder golem core
 * sheathed in rock plates. Frame 0 = armored (sealed, only cracks glow),
 * frame 1 = stunned (plates split apart, molten core exposed). docs/02.
 */
export const bossTerraBody: ProceduralDef = {
  key: 'boss/terra/body',
  width: 150,
  height: 150,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const stunned = frame === 1;
    const split = stunned ? 9 : 0; // plates pull apart when stunned

    // Dust/heat halo
    const halo = ctx.createRadialGradient(c, c, 26, c, c, c);
    halo.addColorStop(0, stunned ? 'rgba(255,138,60,0.4)' : 'rgba(156,122,82,0.22)');
    halo.addColorStop(1, 'rgba(156,122,82,0)');
    circle(ctx, c, c, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Molten core (visible through gaps; bright when stunned)
    circle(ctx, c, c, 30);
    ctx.fillStyle = css(stunned ? COLORS.terraCrack : shade(COLORS.terraCrack, 0.5));
    ctx.fill();

    // Six chunky armor plates around the core, pushed out by `split`
    const plates = 6;
    for (let i = 0; i < plates; i++) {
      const a = (Math.PI * 2 * i) / plates - Math.PI / 2;
      const dx = Math.cos(a) * split;
      const dy = Math.sin(a) * split;
      const inR = 22;
      const outR = 56;
      const wsp = 0.42;
      ctx.beginPath();
      ctx.moveTo(c + dx + Math.cos(a - wsp) * inR, c + dy + Math.sin(a - wsp) * inR);
      ctx.lineTo(c + dx + Math.cos(a - wsp * 0.7) * outR, c + dy + Math.sin(a - wsp * 0.7) * outR);
      ctx.lineTo(c + dx + Math.cos(a + wsp * 0.7) * outR, c + dy + Math.sin(a + wsp * 0.7) * outR);
      ctx.lineTo(c + dx + Math.cos(a + wsp) * inR, c + dy + Math.sin(a + wsp) * inR);
      ctx.closePath();
      fillOutlined(ctx, PLATE, 5);
      // Glowing seam line up each plate
      ctx.strokeStyle = css(stunned ? COLORS.terraCrack : shade(COLORS.terraCrack, 0.6));
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(c + dx + Math.cos(a) * (inR + 4), c + dy + Math.sin(a) * (inR + 4));
      ctx.lineTo(c + dx + Math.cos(a) * (outR - 6), c + dy + Math.sin(a) * (outR - 6));
      ctx.stroke();
    }
    void h;
  },
};
